<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div class="row">
                  <div class="col-sm-12">
                    <h1 style="float:left;">My Listings</h1>
                    <button @click="createListing" style="float:left;margin-left:10px;margin-top:5px;" type="button" class="btn btn-primary btn-orange" aria-label="Left Align">
                      <i class="fa fa-plus fa-sm"></i>
                    </button>
                  </div>
                </div>

                <div class="alert alert-danger alert-orange" role="alert" v-if="this.store.state.cancelListingId">
                  Are you sure you want to delete this listing? This action can't be undone.
                  <br><br>
                  <button @click="confirmDelete" class="btn btn-primary btn-blue">Delete Listing</button>
                  <button @click="confirmCancel" class="btn btn-default">Cancel</button>
                </div>

                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Category</th>
                      <th scope="col">Price</th>
                      <th class="hidden-sm" scope="col">Date Listed</th>
                      <th scope="col"></th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :class="{'row-warning':!listing.paid && listing.price != 'free','row-danger':listing.cancelled}" v-for="listing in store.state.listings" :key="listing.id">
                      <td>{{listing.name}}</td>
                      <td>{{listing.serviceName}}</td>
                      <td><span v-if="listing.price != 'free'">$</span>{{listing.price}}</td>
                      <td class="hidden-sm">{{utils.formatDate(listing.dateListed)}}</td>
                      <td>
                        <button @click="showDetails(listing.id)" class="btn btn-primary btn-blue row-btn">Details</button>
                        <button @click="edit(listing.id)" class="btn btn-primary btn-blue row-btn">Edit</button>
                        <button v-if="listing.price == 'free' || listing.price == '0.00'" @click="cancel(listing.id)" class="btn btn-primary btn-orange row-btn">Delete</button>
                        <a v-else-if="!listing.cancelled && (listing.paid && listing.price != 'free')"  :href="`https://www.paypal.com/myaccount/autopay/connect/${listing.subscr_id}`" target="_blank">
                          <button class="btn btn-primary btn-orange row-btn">Cancel Subscription</button>
                        </a>
                      </td>
                      <td><button v-if="(!listing.paid && listing.price != 'free') || listing.cancelled" @click="pay(listing.id)" class="btn btn-warning btn-orange white">Pay</button></td>
                    </tr>
                  </tbody>
                </table>
                  <small>Want to cancel a listing? You can do so by logging into your PayPal account at paypal.com</small>
              </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import ListingsStore from './ListingsStore'
import AccountSessionUtils from './AccountSessionUtils'

export default {
  name: 'Listings',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: ListingsStore,
      accountUtils: AccountSessionUtils,
      utils: Utils
    }
  },
  mounted () {
    this.store.reset()
    this.accountUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      if(userId == 0){
        this.nav.goLogin(this,"MyListings")
        return
      }
      this.getListings();
    },(err) => {
      this.$toasted.show(err, { type: 'error', duration: 2500 })
    }, () => {
        this.nav.goMaintenance(this)
      })
  },
  methods: {
    getListings: function() {
      let self = this
      this.store.getListings((data) => {
      }, (err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      }, () => {
        this.nav.goMaintenance(this)
      })
    },
    createListing: function() {
      this.$router.push('/account/listing/create')
    },
    showDetails: function(id) {
      this.nav.goListingDetails(this,id)
    },
    pay: function(id) {
      this.nav.goPay(this,id)
    },
    edit: function(id) {
      this.nav.editListing(this,id)
    },
    cancel: function(id) {
      this.store.state.cancelListingId = id
      this.$forceUpdate()
    },
    confirmDelete: function() {
      this.store.cancelFreeListing(() => {
        this.getListings()
        this.store.state.cancelListingId = null
      }, err => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      }, () => {
        this.nav.goMaintenance(this)
      })
    },
    confirmCancel:function() {
      this.store.state.cancelListingId = null
      this.$forceUpdate()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.row-warning {
background:#fbe296 !important;
}
.row-danger {
background:#f8d7da !important;
}

@media screen and (max-width: 540px){
  .row-btn {
    margin:10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/account/Listings.vue